/**
 * GamifiedPathPage.tsx
 * --------------------
 * Page wrapper for the gamified progress path.
 */


import Layout from '../components/common/Layout';
import GamifiedPath from '../components/GamifiedPath';

const GamifiedPathPage = () => {
  return (
    <Layout>
      <GamifiedPath />
    </Layout>
  );
};

export default GamifiedPathPage;
